import type { AgenticLogicRuleDto } from "@intelligems/ig-types/dtos/agentic-logic/rules";
import { SelectionLogicTab } from "./SelectionLogicTab";
import { useOrgExclusionsGraph } from "./useOrgExclusionsGraph";
import { useScenarioPreview } from "./useScenarioPreview";
import { useTemplateSelectionGraph } from "./useTemplateSelectionGraph";

export const TemplateSelectionLogicTab = ({
  rule,
}: {
  rule: AgenticLogicRuleDto;
}) => {
  const { graph, isLoading } = useTemplateSelectionGraph(rule);
  const scenarioPreview = useScenarioPreview({ ruleId: rule.id, graph });
  const canvasGraph = useOrgExclusionsGraph(graph);
  return (
    <SelectionLogicTab
      graph={canvasGraph}
      overlaysByNodeId={scenarioPreview.overlaysByNodeId}
      overlaysByEdgeId={scenarioPreview.overlaysByEdgeId}
      isLoading={isLoading}
      emptyHint="A selection-logic graph could not be generated from this rule's saved configuration."
    />
  );
};
